import { enumToOptions } from '@app/shared/helpers';
import { ThirdPartyTaxValuationUndertakenOnEntry } from '@app/shared/models/contracts/enums/shared-enums';
import { l, translationKeys } from '@locale/setupI18n';

export const getThirdPartyTaxValuationOptions = () =>
  enumToOptions(ThirdPartyTaxValuationUndertakenOnEntry, undefined, true).map((o) => ({
    viewValue: l(o.viewValue as translationKeys),
    value: o.value,
  }));
